
import React from 'react';
import { LucideIcon } from 'lucide-react';

interface InfoItemProps {
  icon: LucideIcon;
  iconColor: string;
  bgColor: string;
  shadowColor: string;
  title: string;
  subtitle: string;
}

const InfoItem = ({ icon: Icon, iconColor, bgColor, shadowColor, title, subtitle }: InfoItemProps) => {
  return (
    <div className="flex flex-col items-center text-center p-3">
      <div className={`flex items-center justify-center h-11 sm:h-14 w-11 sm:w-14 rounded-xl ${bgColor} ${iconColor} mb-3 ${shadowColor}`}>
        <Icon className="h-5 w-5 sm:h-6 sm:w-6" />
      </div>
      <div className="mt-1">
        <p className="text-xs sm:text-sm font-bold text-slate-800 mb-1">{title}</p>
        <p className="text-[10px] sm:text-xs text-slate-500 max-w-[150px] mx-auto">{subtitle}</p>
      </div>
    </div>
  );
};

export default InfoItem;
